import * as functions from './functions.js';

HTMLDocument.prototype.ready = function () {
    return new Promise(function (resolve, reject) {
        if (document.readyState === 'complete') {
            resolve(document);
        } else {
            document.addEventListener('DOMContentLoaded', function () {
                resolve(document);
            });
        }
    });
};
if (window.location.pathname == '/learn/roi-calculator/') {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    let slider1 = document.getElementById('sliderOutput1');
    let slider2 = document.getElementById('sliderOutput2');
    let slider3 = document.getElementById('sliderOutput3');
    let slider4 = document.getElementById('sliderOutput4');

    slider1.addEventListener('change', () => {
        let valAsNumber = parseFloat(slider1.value);
        functions.createCookie('sliderOutput1', valAsNumber);
    });

    slider2.addEventListener('change', () => {
        let valAsNumber = parseFloat(slider2.value);
        functions.createCookie('sliderOutput2', valAsNumber);
    });

    slider3.addEventListener('change', () => {
        let valAsNumber = parseFloat(slider3.value);
        functions.createCookie('sliderOutput3', valAsNumber);
    });

    slider4.addEventListener('change', () => {
        let valAsNumber = parseFloat(slider4.value);
        functions.createCookie('sliderOutput4', valAsNumber);
    });

    function ROI(event) {
        console.log('test');
        document.getElementById('estimations').scrollIntoView({
            behavior: 'smooth'
        });
        // Adjustable variables
        let employees = functions.readCookie('sliderOutput1');
        let servers = functions.readCookie('sliderOutput2');
        let network = functions.readCookie('sliderOutput3');
        let applications = functions.readCookie('sliderOutput4');

        document.getElementById('sliderOutput1').value = employees
        document.getElementById('sliderOutput2').value = servers
        document.getElementById('sliderOutput3').value = network
        document.getElementById('sliderOutput4').value = applications



        //Constant Estimate figures
        const estimateNetworkManagement = 1;
        const estimateITSupport = 0.5;
        const estimateApplications = 0.25;
        const estimateProvisions = 0.25;
        const estimateBoarding = 0.25;
        const estimateSecurity = 0.5;

        const estimateITSalaryCost = 150000;
        const estimateMobileDeviceManagement = 0.5;
        const estimateEndUser050 = 110;
        const estimateEndUser51500 = 72;
        const estimateEndUser5011500 = 65;
        const estimateEndUser1500 = 50;
        const estimateAgioServer050 = 250;
        const estimateAgioServer51500 = 230;
        const estimateAgioServer5011500 = 190;
        const estimateAgioServer1500 = 175;
        const estimateAgioNetwork = 150;

        // Equations - Estimate of Hours Spent on IT-Related Tasks
        const hoursNetworkManagement = employees * estimateNetworkManagement;
        document.getElementById('estimateNetworkManagement').innerHTML = hoursNetworkManagement

        const hoursITSupport = employees * estimateITSupport
        document.getElementById('estimateITSupport').innerHTML = hoursITSupport;

        const hoursApplications = applications * estimateApplications;
        document.getElementById('estimateApplications').innerHTML = hoursApplications;

        const hoursProvisions = employees * estimateProvisions;
        document.getElementById('estimateProvisions').innerHTML = hoursProvisions;

        const hoursOnboarding = employees * estimateBoarding;
        document.getElementById('estimateBoarding').innerHTML = hoursOnboarding;

        const hoursSecurity = employees * estimateSecurity;
        document.getElementById('estimateSecurity').innerHTML = hoursSecurity;

        // Estimate of Cost Related to IT-Related Tasks
        //hoursITSupport removed for now...waiting for updated spreadsheet
        const totalHoursPerMonthIT = hoursNetworkManagement + hoursITSupport + hoursApplications + hoursProvisions + hoursOnboarding + hoursSecurity;
        document.getElementById('estimateHours').innerHTML = totalHoursPerMonthIT
        document.getElementById('estimateHoursMultiply').innerHTML = totalHoursPerMonthIT

        const hourlyITCost = estimateITSalaryCost / 40 / 52 * 1.5;
        document.getElementById('hourlyITCost').innerHTML = formatter.format(hourlyITCost);

        const mobileDeviceManagementSetup = 6600;
        document.getElementById('mobileSetup').innerHTML = formatter.format(mobileDeviceManagementSetup);

        const mobileDeviceManagementAnnual = estimateMobileDeviceManagement * employees * hourlyITCost;
        document.getElementById('mobileAnnual').innerHTML = formatter.format(mobileDeviceManagementAnnual);

        const totalHoursCurrent = (mobileDeviceManagementAnnual + mobileDeviceManagementSetup) + ((hourlyITCost * totalHoursPerMonthIT) * 12);
        document.getElementById('totalInternalCost').innerHTML = formatter.format(totalHoursCurrent);

        // Compared with Agio
        let endUserSupport
        let serverSupport
        let networkSupport

        switch (true) {
            case employees <= 50:
                endUserSupport = employees * estimateEndUser050;
                break;
            case employees >= 51 && employees <= 500:
                endUserSupport = employees * estimateEndUser51500;
                break;
            case employees >= 501 && employees <= 1500:
                endUserSupport = employees * estimateEndUser5011500;
                break;
            case employees > 1500:
                endUserSupport = employees * estimateEndUser1500;
                break;

            default:
                break;
        }

        switch (true) {
            case servers <= 50:
                serverSupport = servers * estimateAgioServer050;
                break;
            case servers >= 51 && servers <= 500:
                serverSupport = servers * estimateAgioServer51500;
                break;
            case servers >= 501 && servers <= 1500:
                serverSupport = servers * estimateAgioServer5011500;
                break;
            case servers > 1500:
                serverSupport = servers * estimateAgioServer1500;
                break;

            default:
                break;
        }

        networkSupport = network * estimateAgioNetwork;



        document.getElementById('costOfITEnvironment').innerHTML = formatter.format(totalHoursCurrent);

        // const annualAgioServiceFee = endUserSupport * 12;
        const annualAgioServiceFee = (endUserSupport + serverSupport + networkSupport) * 12;
        document.getElementById('annualAgioFee').innerHTML = formatter.format(annualAgioServiceFee);

        const totalSavings = totalHoursCurrent - annualAgioServiceFee;
        document.getElementById('totalSavings').innerHTML = formatter.format(totalSavings);

    }


    function ROIstart() {
        console.log('tes3t');
        // Adjustable variables
        // let employees = document.getElementById('sliderOutput1').value
        // let servers = document.getElementById('sliderOutput2').value
        // let network = document.getElementById('sliderOutput3').value
        // let applications = document.getElementById('sliderOutput4').value

        document.getElementById('sliderOutput1').value = 0
        document.getElementById('sliderOutput2').value = 0
        document.getElementById('sliderOutput3').value = 0
        document.getElementById('sliderOutput4').value = 0

        let employees = document.getElementById('sliderOutput1').value
        let servers = document.getElementById('sliderOutput2').value
        let network = document.getElementById('sliderOutput3').value
        let applications = document.getElementById('sliderOutput4').value

        //Constant Estimate figures
        const estimateNetworkManagement = 1;
        const estimateITSupport = 0.5;
        const estimateApplications = 0.25;
        const estimateProvisions = 0.25;
        const estimateBoarding = 0.25;
        const estimateSecurity = 0.5;

        const estimateITSalaryCost = 150000;
        const estimateMobileDeviceManagement = 0.5;
        const estimateEndUser050 = 110;
        const estimateEndUser51500 = 72;
        const estimateEndUser5011500 = 65;
        const estimateEndUser1500 = 50;
        const estimateAgioServer050 = 250;
        const estimateAgioServer51500 = 230;
        const estimateAgioServer5011500 = 190;
        const estimateAgioServer1500 = 175;
        const estimateAgioNetwork = 150;

        // Equations - Estimate of Hours Spent on IT-Related Tasks
        const hoursNetworkManagement = employees * estimateNetworkManagement;
        document.getElementById('estimateNetworkManagement').innerHTML = hoursNetworkManagement

        const hoursITSupport = employees * estimateITSupport
        document.getElementById('estimateITSupport').innerHTML = hoursITSupport;

        const hoursApplications = applications * estimateApplications;
        document.getElementById('estimateApplications').innerHTML = hoursApplications;

        const hoursProvisions = employees * estimateProvisions;
        document.getElementById('estimateProvisions').innerHTML = hoursProvisions;

        const hoursOnboarding = employees * estimateBoarding;
        document.getElementById('estimateBoarding').innerHTML = hoursOnboarding;

        const hoursSecurity = employees * estimateSecurity;
        document.getElementById('estimateSecurity').innerHTML = hoursSecurity;

        // Estimate of Cost Related to IT-Related Tasks
        //hoursITSupport removed for now...waiting for updated spreadsheet
        const totalHoursPerMonthIT = hoursNetworkManagement + hoursITSupport + hoursApplications + hoursProvisions + hoursOnboarding + hoursSecurity;
        document.getElementById('estimateHours').innerHTML = totalHoursPerMonthIT
        document.getElementById('estimateHoursMultiply').innerHTML = totalHoursPerMonthIT

        const hourlyITCost = estimateITSalaryCost / 40 / 52 * 1.5;
        document.getElementById('hourlyITCost').innerHTML = formatter.format(hourlyITCost);

        const mobileDeviceManagementSetup = 6600;
        document.getElementById('mobileSetup').innerHTML = formatter.format(mobileDeviceManagementSetup);

        const mobileDeviceManagementAnnual = estimateMobileDeviceManagement * employees * hourlyITCost;
        document.getElementById('mobileAnnual').innerHTML = formatter.format(mobileDeviceManagementAnnual);

        const totalHoursCurrent = (mobileDeviceManagementAnnual + mobileDeviceManagementSetup) + ((hourlyITCost * totalHoursPerMonthIT) * 12);
        document.getElementById('totalInternalCost').innerHTML = formatter.format(totalHoursCurrent);

        // Compared with Agio
        let endUserSupport
        let serverSupport
        let networkSupport

        switch (true) {
            case employees <= 50:
                endUserSupport = employees * estimateEndUser050;
                break;
            case employees >= 51 && employees <= 500:
                endUserSupport = employees * estimateEndUser51500;
                break;
            case employees >= 501 && employees <= 1500:
                endUserSupport = employees * estimateEndUser5011500;
                break;
            case employees > 1500:
                endUserSupport = employees * estimateEndUser1500;
                break;

            default:
                break;
        }

        switch (true) {
            case servers <= 50:
                serverSupport = servers * estimateAgioServer050;
                break;
            case servers >= 51 && servers <= 500:
                serverSupport = servers * estimateAgioServer51500;
                break;
            case servers >= 501 && servers <= 1500:
                serverSupport = servers * estimateAgioServer5011500;
                break;
            case servers > 1500:
                serverSupport = servers * estimateAgioServer1500;
                break;

            default:
                break;
        }

        networkSupport = network * estimateAgioNetwork;

        document.getElementById('costOfITEnvironment').innerHTML = formatter.format(totalHoursCurrent);

        // const annualAgioServiceFee = endUserSupport * 12;
        const annualAgioServiceFee = (endUserSupport + serverSupport + networkSupport) * 12;
        document.getElementById('annualAgioFee').innerHTML = formatter.format(annualAgioServiceFee);

        const totalSavings = totalHoursCurrent - annualAgioServiceFee;
        document.getElementById('totalSavings').innerHTML = formatter.format(totalSavings);

    }

    if (document.getElementById('sliderOutput1') && document.getElementById('sliderOutput2') && document.getElementById('sliderOutput3') && document.getElementById('sliderOutput4')) {
        //ROIstart();
    }


    var params = functions.getSearchParameters();

    if (params.completed == 'true' || params.completed == true) {
        ROI();
    } else {
        ROIstart();
    }






}
